
import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';


@Component({
  selector: 'subjective-natural-whole-decimal-location-picture-mobile-type',
  templateUrl: './subjective-natural-whole-decimal-location-picture-mobile-type.component.html',
  styleUrls: ['./subjective-natural-whole-decimal-location-picture-mobile-type.component.css']
})
export class SubjectiveNaturalWholeDecimalLocationPictureMobileTypeComponent implements OnInit{

  @Input() heading : string;
  @Input() Qn : string;
  @Input() S_Qn : string;
  @Input() Qn_Type : string;
  glyphiconForHeading : string;
  maxPlaceholder : string;
  isMaxDisabled : boolean;
  Is_Mandt: boolean;
  @Output() maxEntered  = new EventEmitter<string>();
  @Output() primaryQuestionEntered = new EventEmitter<string>();
  @Output() secondaryQuestionEntered = new EventEmitter<string>();
  @Output() isRequiredChanged = new EventEmitter<boolean>();
  primaryQuestionValue : string;
  secondaryQuestionValue : string;
  maxValue : string = "";
  maxDefault : number = 99999999;

  ngOnInit() : void{

    switch (this.heading){
      case 'Subjective':{
        this.heading = "Subjective";
        this.glyphiconForHeading = "glyphicon glyphicon-edit";
        this.maxPlaceholder = "Maximum Characters";
        this.isMaxDisabled = false;
        break;
      }
      case 'NaturalNumMAX':{
        if(this.Qn_Type.substring(13 ,this.Qn_Type.length) !== this.maxDefault.toString()){
          this.maxValue = (this.Qn_Type.substring(13,this.Qn_Type.length));
        }
        this.heading = "Natural";
        this.glyphiconForHeading = "glyphicon glyphicon-pencil";
        this.maxPlaceholder = "Maximum Number";
        this.isMaxDisabled = false;
        break;
      }
      case 'WholeNumMAX':{
        if(this.Qn_Type.substring(11 ,this.Qn_Type.length) !== this.maxDefault.toString()){
          this.maxValue = (this.Qn_Type.substring(11,this.Qn_Type.length));
        }
        this.heading = "Whole";
        this.glyphiconForHeading = "glyphicon glyphicon-pencil";
        this.maxPlaceholder = "Maximum Number";
        this.isMaxDisabled = false;
        break;
      }
      case 'DecimalMax':{
        if(this.Qn_Type.substring(10 ,this.Qn_Type.length) !== this.maxDefault.toString()){
          this.maxValue = (this.Qn_Type.substring(10,this.Qn_Type.length));
        }
        this.heading = "Decimal";
        this.glyphiconForHeading = "glyphicon glyphicon-pencil";
        this.maxPlaceholder = "Maximum Number";
        this.isMaxDisabled = false;
        break;
      }
      case 'Map':{
        this.heading = "Location";
        this.glyphiconForHeading = "glyphicon glyphicon-map-marker";
        this.maxPlaceholder = "Maximum Characters";
        this.isMaxDisabled = true;
        break;
      }
      case 'Picture Input':{
        this.heading = "Picture";
        this.glyphiconForHeading = "glyphicon glyphicon-camera";
        this.maxPlaceholder = "Maximum Characters";
        this.isMaxDisabled = true;
        break;
      }
      case 'MobileNumMAX10':{
        this.heading = "Mobile Number";
        this.glyphiconForHeading = "glyphicon glyphicon-phone";
        this.maxPlaceholder = "Maximum Characters";
        this.isMaxDisabled = true;
        break;
      }
    }

    if(this.Qn && this.Qn.length > 0){
      this.primaryQuestionValue = this.Qn;
    }else{
      this.primaryQuestionValue = "";
    }
    if(this.S_Qn && this.S_Qn.length > 0){
      this.secondaryQuestionValue = this.S_Qn;
    }else {
      this.secondaryQuestionValue = "";
    }

  }

  questionPrimaryEnter(event : any){
    this.primaryQuestionEntered.emit(event.target.value);
  }

  questionSecondaryEnter(event : any){
    this.secondaryQuestionEntered.emit(event.target.value);
  }

  onKeyMax(event: any) {
    event.target.value = event.target.value.match(/[0-9]*/);
    if(event.target.value === '0'){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }
  }

  onEnterMax(event: any){
      this.maxEntered.emit(event.target.value);
  }

  requiredChanged(event : boolean){

    this.isRequiredChanged.emit(event);
  }


}



// WEBPACK FOOTER //
// ./src/app/oldCentralPannel/subjective-natural-whole-decimal-location-picture-mobile-type/subjective-natural-whole-decimal-location-picture-mobile-type.component.ts